'use client'

import { useStoreI18n } from '@/store'
import {
  Button,
  Checkbox,
  FromToDatePicker,
  InputGuest,
  InputSearch
} from '@/ui/components'
import { memo, useState } from 'react'

const BookingBar = () => {
  const locale = useStoreI18n.use.currentLocale()
  const D = useStoreI18n.use.dictionary()

  const [disableDate, setDisableDate] = useState(false)
  const [hasDateFrom, setHasDateFrom] = useState(false)
  const [hasDateTo, setHasDateTo] = useState(false)

  const autoDateUnknown = !disableDate && (!hasDateFrom || !hasDateTo)

  return (
    <div className="p-md hidden bg-neutral-100 md:block">
      <form action={`/${locale}/booking`}>
        <div className="gap-xs grid lg:grid-cols-[1fr_0.5fr_0.5fr_0.5fr_0.5fr_auto]">
          <InputSearch
            label={D['fe.bookingbar.where']}
            placeholder={D['fe.bookingbar.selectValue']}
            className={'flex-1'}
            id="searchtext"
            name="searchtext"
          />
          <FromToDatePicker
            fromName="date_from"
            fromId="date_from"
            fromLabel={D['fe.bookingbar.dateFrom']}
            fromPlaceholder={D['fe.bookingbar.selectValue']}
            toName="date_to"
            toId="date_to"
            toLabel={D['fe.bookingbar.dateTo']}
            toPlaceholder={D['fe.bookingbar.selectValue']}
            disabled={disableDate}
            onFromDateSelect={() => setHasDateFrom(true)}
            onToDateSelect={() => setHasDateTo(true)}
          />
          <InputGuest
            label={D['fe.bookingbar.guest']}
            placeholder={D['fe.bookingbar.selectValue']}
            className={'flex-1'}
          />
          <Button type="submit">{D['fe.bookingbar.search']}</Button>
        </div>
        <div className="mt-xs text-sm text-neutral-600">
          <Checkbox
            onChange={(e) => {
              setDisableDate(e.target.checked)
            }}
            value={disableDate ? '1' : '0'}
            containerClassName="items-center"
            id="date_unknown"
            name="date_unknown"
            label={D['fe.bookingbar.dateUnknown']}
          />
        </div>
        {autoDateUnknown && (
          <input type="hidden" name="date_unknown" value="1" />
        )}
        <input type="hidden" name="doSearch" value="1" />
        <input type="hidden" name="globalReset" value="1" />
      </form>
    </div>
  )
}

BookingBar.displayName = 'BookingBar'

export default memo(BookingBar)
